var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tabs"},[_c('div',{staticClass:"links s-16 w-500"},[_vm._t("link",null,{"activetab":_vm.activetab,"activetabfun":_vm.activetabfun})],2),_c('div',{staticClass:"content contentBody"},[_vm._t("body",null,{"activetab":_vm.activetab})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }